import * as Sentry from "@sentry/vue";

/**
 * We wrap Sentry to avoid initializing it on localhost (to prevent polluting Sentry with dev errors and
 * making the logs unreadable).
 */
export class SentryWrapper {
  static init(app) {
    if (window.location.hostname === 'localhost') {
      // Don't initialize Sentry on localhost
      console.log("Skipping Sentry init on localhost");
      return;
    }
    /*
    Note: Sentry works fine on Chrome, but does not seem to work on Firefox Mac (requests are blocked due to CORS).
    */
    Sentry.init({
      app,
      dsn: "https://78554c998cc6f60838bd2a4ef56f066b@o4507087356821504.ingest.us.sentry.io/4508490908499968",
      integrations: [
        /*
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
        */
      ],
      // Performance Monitoring
      /*
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      */
      debug: true,
      enabled: window.location.hostname !== 'localhost',
    });
  }

  static setUser(user) {
    if (window.location.hostname === 'localhost') {
      // Don't set user on localhost
      return;
    }
    Sentry.setUser(user);
  }

  static captureException(err, context) {
    if (window.location.hostname === 'localhost') {
      // Don't capture exceptions on localhost
      return;
    }
    if (context) {
      Sentry.withScope((scope) => {
        for (const [key, value] of Object.entries(context)) {
          scope.setExtra(key, value);
        }
        Sentry.captureException(err);
      });
    } else {
      Sentry.captureException(err);
    }
  }

  static addBreadcrumb(message, data) {
    if (window.location.hostname === 'localhost') {
      return;
    }
    Sentry.addBreadcrumb({ category: 'app', message, level: 'info', data });
  }
}